  function initNewTestimonialSlider() {
    const testimonialElm = document.querySelector('#new-testimonialSplide');
    if (!testimonialElm) return;

    const isDesignMode = testimonialElm.dataset.isdesignmode === 'true';

    const initSplide = () => {
      if (testimonialElm.splide) testimonialElm.splide.destroy(true);

      const splide = new Splide(testimonialElm, {
        type: 'loop',
        arrows: true,
        center: true,
        pagination: false,
        focus: 'center',
        fixedWidth: 'clamp(300px, 50vw, 600px)',
        gap: '20px',
      });

      splide.mount();
      testimonialElm.splide = splide;

      console.log(' Testimonial Splide initialized');
    };

    initSplide();
  }

  document.addEventListener('DOMContentLoaded', initNewTestimonialSlider);
  document.addEventListener('shopify:section:load', initNewTestimonialSlider);
  document.addEventListener('shopify:block:select', initNewTestimonialSlider);